import React from 'react';

import classNames from 'classnames';

import { Switcher } from '@shared/ui';

import cls from './HeaderInterface.module.css';
import { useHeaderInterface } from './useHeaderInterface';
import { ModeTabs } from '../../../UI/ModeTabs/ModeTabs';

export const HeaderInterface = () => {
    const { settings, onSwitchChange } = useHeaderInterface();

    return (
        <div className={classNames(cls.HeaderInterface)}>
            <Switcher
                classes={cls.switcher}
                title={i18next.t('HeaderInterface.return.Switcher.title')}
                isActive={settings.isShowMHD}
                onClick={onSwitchChange}
            />
            <ModeTabs />
        </div>
    );
};
